import React, { Suspense, lazy, ComponentType } from 'react'
import {
  BrowserRouter,
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom'
import { Splash } from '@/components/splash'
import { ROUTER_BASENAME } from './core/path'
import LaunchEduApp from './pages/launch-edu_app'
const ComplaintSubmmit = lazy(() => import('./pages/complaint/submit'))
const ComplaintSubmitResult = lazy(() => import('./pages/complaint/submit-result'))

export { ROUTER_BASENAME } from './core/path'

//路由里有hijack 表示改页面需要做劫持
//需在session 项目里 加上特例 做单点登录
const Home = lazy(() => import('./pages/home'))
const FourThLetter = lazy(() => import('./pages/four-th-letter'))
const DailyAttendanceList = lazy(() => import('./pages/daily-attendance'))
const Attendance = lazy(() => import('./pages/daily-attendance/attendance'))
const DailyAttendanceRecord = lazy(() =>
  import('./pages/daily-attendance/daily-attendance-record'),
)

// 打卡排行榜
const AttendanceRanking = lazy(() =>
  import('./pages/daily-attendance/attendance-ranking'),
)

const BookingCourses = lazy(() => import('./pages/booking-courses'))
const Form = lazy(() => import('./pages/form'))
const NewForm = lazy(() => import('./pages/new-form'))
const ExamForm = lazy(() => import('./pages/new-form/exam'))
const ExamFormV2 = lazy(() => import('./pages/new-form/exam_v2'))
const Homework = lazy(() => import('./pages/homework/form'))
const HomeworkComment = lazy(() => import('./pages/homework/form/comment'))
const HomeworkCreation = lazy(() => import('./pages/homework-creation'))
const Schedule = lazy(() => import('./pages/schedule_course'))
const GuideApp = lazy(() => import('./pages/guide-app'))
const Share = lazy(() => import('./pages/share'))
const Qrcode = lazy(() => import('./pages/qrcode'))
const QrcodeAgile = lazy(() => import('./pages/qrcode_qywx'))
const QrcodeQwAgile = lazy(() => import('./pages/qrcode_qw'))
const QrcodeQwChannelAgile = lazy(() => import('./pages/qrcode_qw_channel'))
const EnvConfig = lazy(() => import('./pages/env_config'))
const SoundTest = lazy(() => import('./pages/sound-test'))
const Landing = lazy(() => import('./pages/landing'))
const LandingPage = lazy(() => import('./pages/landing-page'))
// const SoundResult = lazy(() => import('./pages/sound-result'))
// const SoundAnalyse = lazy(() => import('./pages/sound-analyse'))
const ScheduleSet = lazy(() => import('./pages/schedule_set'))
const ExamResultList = lazy(() => import('./pages/new-form/examResultList'))
const UnFinishList = lazy(() =>
  import('./pages/new-form/examResultList/unFinish'),
)
const ExamComment = lazy(() => import('./pages/new-form/exam/comment'))
const HappyNews = lazy(() => import('./pages/haapy-news'))
const Cdkey = lazy(() => import('./pages/cdkey'))
const BuyInfo = lazy(() => import('./pages/buy-info'))
const Courses = lazy(() => import('./pages/courses'))
const ContactOperating = lazy(() => import('./pages/contact-operating'))
const RedirectPage = lazy(() => import('./pages/redirect'))
const UniversalLiveCode = lazy(() => import('./pages/universal_live_code'))
const GroupLiveCode = lazy(() => import('./pages/group_live_code'))
const PgcInvite = lazy(() => import('./pages/pgc-invite'))
const PgcSuccess = lazy(() => import('./pages/pgc-invite/success'))
const Invoice = lazy(() => import('./pages/invoice'))
const VideoIframePlayer = lazy(() => import('./pages/video-iframe-player'))
const AudioIframePlayer = lazy(() => import('./pages/audio-iframe-player'))
const ExpressPage = lazy(() => import('./pages/express/index'))
const MallQrcode = lazy(() => import('./pages/mall-qrcode/index'))
const MPRedirect = lazy(() => import('./pages/mp-redirect/index'))
const CertUpload = lazy(() => import('./pages/cert/upload'))
const CertCreated = lazy(() => import('./pages/cert/created'))
const CertCreating = lazy(() => import('./pages/cert/creating'))
const CertFailed = lazy(() => import('./pages/cert/failed'))
const EarlyEduForm = lazy(() => import('./pages/early-edu-form'))
const EarlyEduFormResult = lazy(() => import('./pages/early-edu-form/result'))
const OrderListExpress = lazy(() => import('./pages/order-list-express'))
const DeliveryList = lazy(() => import('./pages/delivery-list'))
const LihuaGuideDownload = lazy(() => import('./pages/lihua-guide-download'))
const CheckBatchUrlPage = lazy(() => import('./pages/check-url'))
const PaySuccessPage = lazy(() => import('./pages/pay-success'))
const ViewerPage = lazy(() => import('./pages/viewer/viewer'))
const InvoiceGuide = lazy(() => import('./pages/invoice-guide'))

const BindPhoneNumber = lazy(() => import('./pages/bind-phone-number'))
const BrowserGuide = lazy(() => import('./pages/browser-guide/index'))

const ComplaintPage = lazy(() => import('./pages/complaint/index'))

const PurchaseNotice = lazy(() => import('./pages/purchase-notice/index'))

// 微信客服留言
const WechatMessage = lazy(() => import('./pages/wechat-message'))
const WechatMessageList = lazy(() => import('./pages/wechat-message/components/list'))

const routes: [string, ComponentType<any>][] = [
  ['/letter', FourThLetter],
  ['/attendancelist/:lectureId/:morningReadingId', DailyAttendanceList],
  ['/attendance/:lectureId/:morningReadingId', Attendance],
  ['/attendancerecord/:lectureId/:morningReadingId', DailyAttendanceRecord],
  ['/attendance_ranking/:lectureId/:morningReadingId', AttendanceRanking],
  ['/booking/:channel_id', BookingCourses],
  ['/form/:form_id', Form],
  ['/newform/:form_id', NewForm], // 新版表单组件
  ['/examform/:form_id', ExamForm], // 考核表单组件
  ['/examform_v2/:form_id', ExamFormV2], // 考核表单组件-写作样式
  ['/homework/comment/:lecture_id', HomeworkComment], // 讲师点评学员作业
  ['/homework/:lecture_id', Homework], //  作业
  ['/homework_creation/:lecture_id', HomeworkCreation], //  作业-作品集
  ['/schedule/:liveroom_id', Schedule],
  ['/guide_app', GuideApp],
  ['/schedule_set/:liveroom_id', ScheduleSet],
  ['/share/:activity', Share],
  ['/qrcode/:a_id', Qrcode],
  ['/qrcode_qywx/:a_id', QrcodeAgile],
  ['/qrcode_qw/:agile_code_id', QrcodeQwAgile],
  ['/qrcode_qw_channel/:agile_code_id', QrcodeQwChannelAgile],
  ['/env_config', EnvConfig],
  ['/fission_activity', SoundTest], // 声音测试页
  ['/landingPage', LandingPage],
  ['/launch_edu_app', LaunchEduApp],
  ['/landing/:activity_id', Landing],
  ['/happy_news/:channel_id', HappyNews],
  // ['/fission_activity_result/:activity_id', SoundResult], // 声音测试结果页
  // ['/fission_activity_analyse/:activity_id', SoundAnalyse], // AI声音检测页
  ['/exam_resultList/:form_id', ExamResultList], // 考试提交结果列表页
  ['/un_finishList/:form_id', UnFinishList], // 考试提交结果列表页
  ['/exam_comment/:form_id/:record_id', ExamComment], // 考试提交结果列表页
  ['/cdkey', Cdkey], // 激活码激活页面
  ['/buy_info', BuyInfo], // 购买信息
  ['/courses/:goods_id', Courses], //梨花商城领取课程
  ['/contact_operating', ContactOperating], //联系运营客服
  ['/redirect', RedirectPage], //邀请卡重定向页面
  ['/universal_live_code/:merchant_id/:code_id', UniversalLiveCode], // 群控万能活码
  ['/group_live_code/:merchant_id/:code_id', GroupLiveCode], // 群控群活码
  ['/pgc_invite/:invite_key', PgcInvite], // PGC权限后台邀请用户进入组织架构
  ['/pgc_invite_success', PgcSuccess], // PGC权限后台邀请用户进入组织架构-成功页面
  ['/invoice/:product_id', Invoice], // 发票申请
  ['/video_iframe_player', VideoIframePlayer], // 专栏视频封面iframe
  ['/audio_iframe_player', AudioIframePlayer], // 专栏音频iframe
  ['/express', ExpressPage],
  ['/mall_qrcode', MallQrcode],
  ['/mp-redirect', MPRedirect],
  ['/cert_upload', CertUpload],
  ['/cert_created', CertCreated],
  ['/cert_creating', CertCreating],
  ['/cert_failed', CertFailed],
  ['/early_edu_form', EarlyEduForm],
  ['/early_edu_form_result', EarlyEduFormResult],
  ['/order_list_express', OrderListExpress],
  ['/delivery_list', DeliveryList],
  ['/lihua_app_download', LihuaGuideDownload],
  ['/pay_success', PaySuccessPage],
  ['/viewer', ViewerPage],
  ['/invoice_guide', InvoiceGuide], // 开票指引页面
  ['/bind_phone_number', BindPhoneNumber], // 绑定手机号页面
  ['/klm_rnd', BrowserGuide],
  ['/check_url', CheckBatchUrlPage],
  ['/complaint', ComplaintPage],
  ['/complaint_submit', ComplaintSubmmit],
  ['/complaint_submit_result', ComplaintSubmitResult],
  ['/purchase_notice', PurchaseNotice],
  ['/wechat_message', WechatMessage], // 微信客服留言
  ['/wechat_message_list', WechatMessageList], // 微信客服留言列表
]

export function Routers() {
  return (
    <BrowserRouter basename={ROUTER_BASENAME}>
      <Suspense fallback={<Splash />}>
        <Switch>
          <Route path="/" exact component={Home} />
          {routes.map(([path, component]) => {
            return <Route path={path} component={component} key={path} />
          })}
        </Switch>
      </Suspense>
    </BrowserRouter>
  )
}
